import ky, { HTTPError } from 'ky';
import { ENV } from 'src/utils/env';
import { capitalize } from 'lodash';
import { STORES_CONFIG_GET_ALL_RESPONSE_SCHEMA, STORES_CONFIG_SCHEMA, StoreConfigSchema } from './storesSchema';

export const listStoresPromise = async (params: StoreConfigSchema) => {
  const parsedParams = STORES_CONFIG_SCHEMA.safeParse(params);

  if (!parsedParams.success) {
    throw new Error('invalid params');
  }

  try {
    const response = await ky.post(`${ENV.FRONTEND_API_URL}/stores`, {
      body: JSON.stringify(parsedParams.data),
    });

    const validatedResponse = STORES_CONFIG_GET_ALL_RESPONSE_SCHEMA.safeParse(await response.json());

    if (!validatedResponse.success) {
      console.error('Error in Response');
      throw new Error('Error in Response', validatedResponse.error);
    }

    const addIdToStore = validatedResponse.data.data.data.map((store) => ({ ...store, id: store.uuid }));

    return {
      ...validatedResponse.data.data,
      data: addIdToStore,
      asOptions: validatedResponse.data.data.data.map((store) => ({
        label: capitalize(store.store_name || ''),
        value: store.uuid,
        id: store.uuid,
      })),
    };
  } catch (error) {
    if (error instanceof HTTPError) {
      let errorRes = error;

      try {
        errorRes = await error.response.json();
      } catch {
        //
      }

      throw new Error(errorRes?.message);
    }

    throw new Error((error as Error)?.message || 'Error while getting store(s)');
  }
};

export type GetStoresPromiseData = Awaited<ReturnType<typeof listStoresPromise>>;
